// extracted by css-extract-rspack-plugin
var _1 = "qae0VFrlVQyfguuhz07KmQ--";
export { _1 as "border" }
